import React from "react";
import CardOne from "../Cards/CardOne";
import UserOneImage from "../../Assets/users/user1.png";
import StackGrid from "react-stack-grid";
import DownArrow from "../../Assets/down-arrow.png";
import { ExpandIcon, MobileHiddenDiv, MobileVisibleDiv } from "./styles";
import { ViewMoreButton } from "../Common";

const data = [
  {
    title: "Rishab nair",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "Loving this app. I am a pretty good copywriter, but this thing is gold! It will save me a ton of time coming up with fresh content. I give it some basic ideas and it spits out straight",
  },
  {
    title: "Ashutosh kapoor",
    title2: "Guitarist",
    imageUrl: UserOneImage,
    description:
      "This AI is freaking incredible. Writing content for my company used to take hours and my brain would be mush at the end of each day. With Jarvis, I can spark creativity at any point in the day - whether I'm building out trainings, copywriting for social media, or creating books for lead generation. My only wish is that I could have met Jarvis (the AI's name) sooner! I have shown a brief glimpse at what the AI does to other friends of mi....",
    expandIcon: true,
  },
  {
    title: "Tiara shah",
    title2: "Guitarist",
    imageUrl: UserOneImage,
    description:
      "Loving this app. I am a pretty good copywriter, but this thing is gold! It will save me a ton of time coming up with fresh content. ",
  },

  {
    title: "Rishab nair",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "Loving this app. I am a pretty good copywriter, but this thing is gold! It will save me a ton of time coming up with fresh content. I give it some basic ideas and it spits out straight. It's like I've employed a full-time copywriter for 10% of the cost!",
  },
  {
    title: "Rishab nair",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "This AI is freaking incredible. Writing content for my company used to take hours and my brain would be mush at the end of each day. With Jarvis, I can spark creativity at any point in the day - whether I'm building out trainings, copywriting for social media, or creating books for lead generation. My only wish is that I could have met Jarvis (the AI's name) sooner! I have shown a brief glim.....",
    expandIcon: true,
  },
  {
    title: "Tiara shah",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "Loving this app. I am a pretty good copywriter, but this thing is gold! It will save me a ton of time coming up with fresh content. I give it some basic ideas and it spits out straight. I just discovered this tool today from the Trends group, and I am already blown away. Brilliant tool you guys have made here! I love how quick and easy it is to create great copy, and honestly writes way better than I ever could.This AI is freaking incredible. With Jarvis, I can spark creativity at any point in the day ",
  },
  {
    title: "Ram kapurr",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "I just discovered this tool today from the Trends group, and I am already blown away. Brilliant tool you guys have made here! I love how quick and easy it is to create great copy, and honestly writes way better than I ever could. ",
  },
  {
    title: "Tiara shah",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "This AI is freaking incredible. Writing content for my company used to take hours and my brain would be mush at the end of each day. With Jarvis, I can spark creativity at any point in the day - whether I'm building out trainings, copywriting for social media, or creating books for lead generation. My only wish is that I could have met Jarvis (the AI's name) sooner! I have shown a brief glimpse at what the AI does to other friends of mine in business and they were shocked just with one tool - BUT the team is constantly expanding the types of content that the AI produces. Thank you for developing such a time/life saving tool ",
  },
  {
    title: "Ram kapur",
    title2: "Founder at RA Marketing",
    imageUrl: UserOneImage,
    description:
      "This AI is freaking incredible. Writing content for my company used to take hours and my brain would be mush at the end of each day. With Jarvis, I can spark creativity at any point in the day - whether I'm building out trainings, copywriting for social media, or creating books for lead generation. My only wish is that I could have met Jarvis (the AI's name) sooner! I have shown a brief glimpse at what the AI does to other friends of mine in business and they were shocked just with one tool - BUT the team is constantly expanding the types of content that the AI produces. Thank you for developing such a time/life saving tool ",
  },
  {
    title: "Ashutosh kapoor",
    title2: "Guitarist",
    imageUrl: UserOneImage,
    description:
      "I just discovered this tool today from the Trends group, and I am already blown away. Brilliant tool you guys have made here! I love how quick and easy it is to create great copy, and honestly writes way better than I ever could. ",
  },
  {
    title: "Tiara shah",
    title2: "Ceo at shopifyquuickly",
    imageUrl: UserOneImage,
    description:
      "Loving this app. I am a pretty good copywriter, but this thing is gold! It will save me a ton of time coming up with fresh content. I give it some basic ideas and it spits out straight",
  },
];

const CustomGrid = ({ isViewMoreIcon, isViewMoreButton = true }) => {
  const [cardNumber, setCardNumber] = React.useState(15);
  const setCardNumberFunc = () => {
    if (window.innerWidth <= 768) {
      setCardNumber(5);
    } else {
      setCardNumber(15);
    }
  };
  React.useEffect(() => {
    window.addEventListener("resize", setCardNumberFunc);
    setCardNumberFunc();
    return () => {
      window.removeEventListener("resize", setCardNumberFunc);
    };
  });
  return (
    // <Container>
    <div
      style={{
        padding: "25px 0px",
        maxWidth: "1300px",
        margin: "0px auto",
        position: "relative",
      }}
    >
      <StackGrid columnWidth={300} gutterWidth={25} gutterHeight={25}>
        {data?.slice(0, cardNumber - 1)?.map((item, index) => (
          <CardOne
            title={item.title}
            title2={item.title2}
            description={item.description}
            imageUrl={item.imageUrl}
            expandIcon={item.expandIcon}
            key={index}
          />
        ))}
      </StackGrid>
      {isViewMoreButton ? (
        <ViewMoreButton>View More</ViewMoreButton>
      ) : (
        <MobileVisibleDiv>
          <ViewMoreButton>View More</ViewMoreButton>
        </MobileVisibleDiv>
      )}

      {isViewMoreIcon && (
        <MobileHiddenDiv>
          <ExpandIcon src={DownArrow} />
        </MobileHiddenDiv>
      )}
    </div>
    // </Container>
  );
};

export default CustomGrid;
